export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/authentication/login/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("@/views/authentication/signup/index.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: false,
    },
  },
  {
    path: "/forget-password",
    name: "forget-password",
    component: () =>
      import("@/views/authentication/forgetPassword/ForgetPassword.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: false,
    },
  },
  {
    path: "/create-new-vendor",
    name: "create-new-vendor",
    component: () => import("@/views/authentication/createNewVendor/index.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: false,
    },
  },
  {
    path: "/vendor-pending",
    name: "vendor-pending",
    component: () => import("@/views/authentication/vendorPending/index.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: false,
    },
  },
];
